import { baseApi } from "@/shared/api";
import type {
  SessionResponse,
  LoginRequest,
  RegisterRequest,
  User,
  CreateCharacterRequest,
  SslRegisterRequest,
  SslPasswordResetRequest,
  SslPasswordResetConfirmRequest,
} from "../model/types";
import { setToken } from "../model/auth.slice";

export const sessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    userInfo: builder.query<User, void>({
      query: () => ({ url: "/user_info/", method: "GET" }),
      providesTags: ["User"],
    }),
    createCharacter: builder.mutation<void, CreateCharacterRequest>({
      query: (body) => ({ url: "/create_character/", method: "POST", body }),
      invalidatesTags: ["User"],
    }),
    login: builder.mutation<SessionResponse, LoginRequest>({
      query: (body) => ({ url: "/login/", method: "POST", body }),
      invalidatesTags: ["User"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // Сохраняем токен в Redux и localStorage
          dispatch(setToken(data.token));
        } catch (error) {
          // Ошибка обработается автоматически
        }
      },
    }),
    register: builder.mutation<SessionResponse, RegisterRequest>({
      query: (body) => ({ url: "/register/", method: "POST", body }),
      invalidatesTags: ["User"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // Сохраняем токен в Redux и localStorage
          dispatch(setToken(data.token));
        } catch (error) {
          // Ошибка обработается автоматически
        }
      },
    }),
    sslLogin: builder.mutation<SessionResponse, LoginRequest>({
      query: (body) => ({ url: "/ssl/login/", method: "POST", body }),
      invalidatesTags: ["User"],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setToken(data.token));
        } catch {
          // ошибка отображается на форме
        }
      },
    }),
    sslRegister: builder.mutation<SessionResponse, SslRegisterRequest>({
      query: (body) => ({ url: "/ssl/register/", method: "POST", body }),
      invalidatesTags: ["User"],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setToken(data.token));
        } catch {
          // ошибка отображается на форме
        }
      },
    }),
    sslPasswordResetRequest: builder.mutation<
      { ok: boolean },
      SslPasswordResetRequest
    >({
      query: (body) => ({
        url: "/ssl/password_reset/request/",
        method: "POST",
        body,
      }),
    }),
    sslPasswordResetConfirm: builder.mutation<
      SessionResponse,
      SslPasswordResetConfirmRequest
    >({
      query: (body) => ({
        url: "/ssl/password_reset/confirm/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setToken(data.token));
        } catch {
          // ошибка отображается на форме
        }
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useUserInfoQuery,
  useCreateCharacterMutation,
  useSslLoginMutation,
  useSslRegisterMutation,
  useSslPasswordResetRequestMutation,
  useSslPasswordResetConfirmMutation,
} = sessionApi;
